angular.module('picmonicng').factory('schoolClassResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/schools/:school_id/classes/:school_class_id',
      { school_id: '@school_id', school_class_id: '@school_class_id' },
      {
        update: { method: 'PUT' },
        removeStudent: {
          method: 'DELETE',
          url: '/api/v3/schools/:school_id/classes/:school_class_id/student',
          isArray: false,
        },
      }
    );
  },
]);
